
























































import DialogoDeEdicaoDeCliente from '@/components/cliente/DialogoDeEdicaoDeCliente.vue';
import Confirmacao from '@/components/ui/Confirmacao.vue';
import DataTableDeCrudPaginado from '@/components/ui/DataTableDeCrudPaginado.vue';
import { Adquirente, Cliente, Page, Pageable } from '@/models';
import { criarCliente } from '@/shareds/cliente-shareds';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore';
import { FindAdquirenteUseCase } from '@/usecases/venda/FindAdquirenteUseCase';
import { SaveAdquirenteUseCase } from '@/usecases/venda/SaveAdquirenteUseCase';
import { CancelToken } from 'axios';
import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import DialogoDeEdicaoDeAdquirente from './DialogoDeEdicaoDeAdquirente.vue';

@Component({
	components: {
		DataTableDeCrudPaginado,
		DialogoDeEdicaoDeAdquirente,
		Confirmacao,
		DialogoDeEdicaoDeCliente,
	},
})
export default class TelaDeCadastroDeAdquirente extends Vue {
	@Ref() dataTablePaginado!: DataTableDeCrudPaginado
	@Ref() dialogoDeEdicaoDeAdquirente!: DialogoDeEdicaoDeAdquirente
	@Ref() dialogoDeEdicaoDeCliente!: DialogoDeEdicaoDeCliente

	findAdquirenteUseCase = new FindAdquirenteUseCase()
	saveAdquirenteUseCase = new SaveAdquirenteUseCase()
	busca = ''
	adquirente: Adquirente[] = []
	carregando = false
	editando = false

	headers = [
		{ text: 'Adquirente', value: 'razaoSocialOuNome' },
	]

	async buscarPagina(paginavel: Pageable, parametros: {
		busca?: string
	}, cancelToken: CancelToken): Promise<Page<Adquirente>> {
		const pagina = await this.findAdquirenteUseCase.findAll({
			...parametros,
			...paginavel,
		}, {
			cancelToken,
		})
		this.adquirente = pagina.content
		return pagina
	}

	
	abrirDialogoDeEditarAdquirente(indice: number) {
		try {
			if(!this.temRecurso('alterar', "adquirentes")) {
				throw new Error('Necessário permissão para editar')
			}
			this.editando = true
			const adquirente = this.adquirente[indice]
			this.dialogoDeEdicaoDeAdquirente.mostrar(adquirente, true)
		} catch(error) {
			AlertModule.setError(error)
		}
	}

	abrirDialogoDeCriarAdquirente(cadastroPadrao: boolean) {
		try {
			if(!this.temRecurso('criar', 'adquirentes')) 
				throw new Error('Necessário permissão para criar')
			this.editando = true
			const adquirente = {id:"",razaoSocialOuNome:"",cnpjOuCpf:""}

			if (cadastroPadrao){
				this.dialogoDeEdicaoDeAdquirente.mostrar(adquirente, cadastroPadrao)
			} else {
				const cliente = criarCliente()
				this.dialogoDeEdicaoDeCliente.mostrar(cliente, true)
			}
			
		} catch(error) {
			AlertModule.setError(error)
		}
	}

	criarRegistro(adquirente: Adquirente) {
		this.adquirente.push(adquirente)
	}

	atualizarRegistro(adquirente: Adquirente) {
		const indice = this.adquirente.findIndex( adquirenteExistente => adquirenteExistente.id === adquirente.id)
		this.adquirente.splice(indice, 1, adquirente)
	}

	get temRecurso() {
		return UserLoginStore.temAutorizacaoPorOperacaoERecurso
	}

	@Watch('busca')
	novaBusca() {
		this.dataTablePaginado.reiniciar({
			busca: this.busca,
		})
	}

	@Watch('carregando')
	onChangeMostrar() {
		this.dataTablePaginado.reiniciar({
			busca: this.busca,
		})
	}

	async criarRegistroDeAdquirenteComCliente(clienteSalvo: Cliente){
		const adquirente = {
			id:"",
			razaoSocialOuNome: clienteSalvo.razaoSocialOuNome.toUpperCase(),
			cnpjOuCpf:clienteSalvo.cnpjOuCpf,
			ativo: true,
		}

		const adquirenteSalvo = await this.saveAdquirenteUseCase.create(adquirente)
		this.criarRegistro(adquirenteSalvo)
		this.novaBusca();
	}
}
